import React, { useEffect, useRef } from 'react'
import { EditFilledIcon } from '@mote/assets/icons'
import {
  StyledContentEditable,
  StyledContentEditableWrapper,
  StyledIconWrapper
} from './ContentEditable.styles'

export interface ContentEditableProps {
  onBlur: (value: string) => void
  value: string
  placeholder: string
  newLineDisabled?: boolean
  isReadonly?: boolean
  dataTestId?: string
}

export function ContentEditable(props: ContentEditableProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.innerText = props.value
    }
  }, [props.value])

  return (
    <StyledContentEditableWrapper>
      <StyledContentEditable
        ref={ref}
        data-testid={props.dataTestId}
        placeholder={props.placeholder}
        isReadonly={props.isReadonly}
        {...(!props.isReadonly && {
          tabIndex: 0,
          contentEditable: true,
          onKeyDown: handleKeyDown,
          onKeyUp: handleKeyUp,
          onBlur: handleBlur,
          role: 'textbox',
          'data-content-editable': true
        })}
      />
      {!props.isReadonly && (
        <StyledIconWrapper>
          <EditFilledIcon />
        </StyledIconWrapper>
      )}
    </StyledContentEditableWrapper>
  )

  function handleBlur(e: React.FocusEvent<HTMLDivElement>) {
    props.onBlur(e.target.innerText)
  }

  function handleEnterKey(e: React.KeyboardEvent<HTMLDivElement>) {
    if (props.newLineDisabled) {
      e.preventDefault()
    }
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    switch (e.key) {
      case 'Enter':
        handleEnterKey(e)
        break
    }
  }

  function handleKeyUp(e: React.KeyboardEvent<HTMLDivElement>) {
    const target = e.target as HTMLDivElement
    if (target.textContent === '') {
      target.textContent = ''
    }
  }
}
